import * as React from "react";

import Footer from "@components/UI/Footer";
import Header from "@components/UI/Header/Header";
import Loader from "@components/UI/Loader";

interface IStandardLayout {
  route?: string;
  hideSearchForm?: boolean;
  showCondensedHeaderLogoStripe?: boolean;
  hideFooter?: boolean;
  hideFooterRights?: boolean;
  nonce?: string;
  children?: React.ReactNode;
}

const StandardLayout: React.FC<IStandardLayout> = ({
  hideFooter,
  hideFooterRights,
  route,
  showCondensedHeaderLogoStripe,
  hideSearchForm,
  children,
  nonce,
}) => {
  return (
    <>
      <div className="layout layout--standard">
        <div className="main-wrapper">
          <Header
            nonce={nonce}
            showCondensedHeaderLogoStripe={showCondensedHeaderLogoStripe}
            hideSearchForm={hideSearchForm}
          />
        </div>
        {children}
        <Loader />
      </div>
      {hideFooter !== true && (
        <Footer hideRights={hideFooterRights} route={route} nonce={nonce} />
      )}
    </>
  );
};

export default StandardLayout;
